module.exports = __webpack_public_path__ + "img/special_banner.jpg?v=b02e3397";